import AppLoading from 'expo-app-loading';
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import useFonts from './hooks/useFonts';
import HomeScreen from './screens/HomeScreen';
import store from './store/redux';

const App: React.VFC = () => {
	const { fontsLoaded } = useFonts();

	if (!fontsLoaded) {
		return <AppLoading />;
	}
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistStore(store)}>
				<StatusBar hidden />
				<HomeScreen />
			</PersistGate>
		</Provider>
	);
};

export default App;
